import React from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import "./style.css";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import { LOGIN_PAGE, REGISTRATION_SUCCESS_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import { CREATE_NEW_USER_URL } from "../../api/apiRoutes";
import { WebUser } from "../../models/WebUser";
import useFacility from "../../../utils/hooks/useFacility";
import { FormElementModel } from "../../models/FormElementModel";
import { userRegisterForm } from "./inputsForm/InputRegisterFormModels";
import CheckBoxInput from "../../../utils/CheckBoxInput";

type Inputs = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  repeatPassword: string;
  phone: string;
  acceptStatute: boolean;
};

const Registration: React.FC = () => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      acceptStatute: false,
    },
  });

  const handleRegistration: SubmitHandler<Inputs> = async (data) => {
    const webUser: WebUser = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      password: data.password,
      phone: data.phone,
      allowMailing: false,
    } as WebUser;
    const { isError } = await post(CREATE_NEW_USER_URL(facilityIds), webUser);
    if (!isError) {
      navigate(REGISTRATION_SUCCESS_PAGE);
    }
  };

  return (
    <div className={isDesktop ? "login-wrapper" : "login-wrapper-mobile"}>
      <div className={isDesktop ? "login-panel" : "login-panel-mobile"}>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <h3 className={"registration-panel-title"}>Zarejestruj się</h3>
          {userRegisterForm(watch, register).map((item: FormElementModel, index: number) => (
            <FormInput key={index} {...item} errors={errors} />
          ))}

          <Controller
            name={"acceptStatute"}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <CheckBoxInput
                name={"acceptStatute"}
                field={field}
                title={
                  <span>
                    * Kontynuując, akceptujesz regulamin korzystania z serwisu eAktywni, Politykę prywatności oraz
                    warunki korzystania z plików cookie.
                  </span>
                }
                errors={errors}
              />
            )}
          />

          <div className={"div-buttons"}>
            <input className={"login-button"} type={"submit"} value={"Zarejestruj się"} />
            <span>lub</span>
            <button className={"register-button"} onClick={() => navigate(LOGIN_PAGE)}>
              Zaloguj się
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registration;
